'use strict';

require("core-js/modules/es6.regexp.replace");

module.exports = normalize;

function normalize(value) {
  return value.toLowerCase().replace(/\b[:-]\b/g, '');
}